import { type Node } from "@xyflow/react";
import { DEFAULT_NODE_WIDTH, PATH_NODE_WIDTH } from "@zapier/canvas-constants";

/**
 * Annotation positioning offsets for different node types
 */
const ANNOTATION_OFFSETS = {
  path: PATH_NODE_WIDTH / 2, // 60px to center on path nodes (diamond shape)
  default: DEFAULT_NODE_WIDTH / 2, // 140px to center on regular nodes
} as const;

/**
 * Calculates the x-offset for positioning an annotation node on its parent
 * Uses constants-based lookup for cleaner, more maintainable code
 */
export function calculateAnnotationXOffset(parentNode?: Node): number {
  if (!parentNode) return 0;
  return (
    ANNOTATION_OFFSETS[parentNode.type as keyof typeof ANNOTATION_OFFSETS] ??
    ANNOTATION_OFFSETS.default
  );
}
